import { Component, OnInit } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { UtilityService } from '../../core/services/utility.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { PollService } from '../../core/services/poll.service';
import { Poll } from '../../core/models/poll';
import { PollQuestionModel } from '../../core/models/poll-question';
import { PollListService } from '../../core/services/poll-list.service';
import { setTimeout } from 'timers';

/** bulk upload imports start */
import * as XLSX from 'xlsx';
import { FileUpload } from 'primeng/primeng';
import { ExportImportSessionService } from '../../core/services/export-import-session.service';
import { PollOptionsModel } from '../../core/models/poll-options';
/** bulk upload imports end */

@Component({
  selector: 'app-poll-form',
  templateUrl: './poll-form.component.html',
  styleUrls: ['./poll-form.component.css'],
  providers: [ExtraService, UtilityService, PollService, PollListService, ExportImportSessionService, DatePipe]
})
export class PollFormComponent implements OnInit {
  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;

  eventID: string;
  message: string;
  pollId: string = null;
  pollTitle: string = 'Session Data';
  pollEmptyId: string = null;
  pollList: Array<Poll> = new Array();
  pollIdList: Array<any> = new Array();
  poll = new Poll();
  eventLists: boolean;

  pollQuestionList: Array<PollQuestionModel> = new Array();
  pollQuestionIdList: Array<any> = new Array();

  totalAnswer = new Array<any>();
  checkData: boolean = false;
  selectedFile: File = null;
  keys = {
    PollKey: "PollKey",
    PollQuestions: "PollQuestions",
    PollType: 'PollType',
    PollOptions: 'PollOptions',
    IsMandatory: 'IsMandatory',
    ShowResult: 'ShowResult',
    AllowOverwrite: 'AllowOverwrite',
    IsRelease: 'IsRelease',
  };

  constructor(private pollListService: PollListService, private extraService: ExtraService, private route: ActivatedRoute, private confirmationService: ConfirmationService,
    private pollService: PollService, private utilityService: UtilityService, private router: Router, private location: Location, private eximSessionService: ExportImportSessionService, public datepipe: DatePipe,) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {
      if (params['eventId']) {
        this.eventID = params['eventId'];
        this.extraService.setCurrentEventId(params['eventId']);
        this.checkData = true;
        this.setPollList(params['eventId']);
        this.setPollQuestionList(params['eventId']);
        //this.setPollListData(id);
      }
    });
  }

  upMenuItem(index) {
    if (index != 0) {
      this.swap(index, index - 1);
    }
  }

  downMenuItem(index) {
    if (index != this.pollList.length - 1) {
      this.swap(index, index + 1);
    }
  }

  swap(index1, index2) {
    let data = this.pollList[index1];
    this.pollList[index1] = this.pollList[index2];
    this.pollList[index2] = data;
    console.log(this.pollList);
  }

  submit() {
    for (var i = 0; i < this.pollList.length; i++) {
      this.pollList[i].position = i;
    }
    this.pollService.updatePollPosition(this.eventID, this.pollList, this.pollDeletedIdList);
    // if (this.pollDeletedIdList.length > 0) {
    //   this.message = "Poll deleted Successfully";
    // } else {
    this.message = "Poll ordered Successfully";
    //}
    setTimeout(() => {
      this.message = null;
      this.checkData = true;
    }, 2000);
  }

  validateFileNameTopicField(polls: any): boolean {
    let breakLoop: boolean;
    polls.some(el => {
      if (el[this.keys['PollKey']] !== undefined || !breakLoop) {
        if (el[this.keys['PollKey']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
      if (el[this.keys['PollQuestions']] !== undefined || !breakLoop) {
        if (el[this.keys['PollQuestions']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
      if (el[this.keys['PollType']] !== undefined || !breakLoop) {
        if (el[this.keys['PollType']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
      // if (el[this.keys['PollOptions']] !== undefined || !breakLoop) {
      //   if (el[this.keys['PollOptions']] === '') {
      //     breakLoop = true;
      //   }
      // } else {
      //   breakLoop = true;
      // }
      if (el[this.keys['IsMandatory']] !== undefined || !breakLoop) {
        if (el[this.keys['IsMandatory']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
      if (el[this.keys['ShowResult']] !== undefined || !breakLoop) {
        if (el[this.keys['ShowResult']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
      if (el[this.keys['PollKey']] !== undefined || !breakLoop) {
        if (el[this.keys['PollKey']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
      if (el[this.keys['AllowOverwrite']] !== undefined || !breakLoop) {
        if (el[this.keys['AllowOverwrite']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
      if (el[this.keys['IsRelease']] !== undefined || !breakLoop) {
        if (el[this.keys['IsRelease']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
    });

    if (breakLoop) return false;
    else return true;
  }

  removeFileInstance(event: any, uploader: FileUpload, index: number) {
    uploader.remove(event.files[0], 0);
  }
  importPollQues(event: any, uploader: FileUpload) {

    console.log("polls")
    let bulkUploadTrigger: boolean = false;
    let options: any;
    let payloadArr: any = [];
    this.selectedFile = event.files[0];
    this.eximSessionService.importSessions(this.selectedFile).then(sessionBulk => {
      //debugger
      if (!this.validateFileNameTopicField(sessionBulk)) {
        this.message = 'It seems, some records don\'t have name value or name length should greater or equal to three character. Please fix before update.';
        setTimeout(() => {
          this.removeFileInstance(event, uploader, 0);
          this.message = null;
        }, 2000);
      } else {
        let pollsExcelData = sessionBulk
        if (pollsExcelData.length > 0) {

          pollsExcelData.map((x) => {
            let opts: any
            if (x.PollOptions != "" && x.PollOptions != null && x.PollOptions != undefined) {
              let firstOpts = x.PollOptions.replace(/'/g, '"');
              let secondOpts = firstOpts.replace(/‘/g, '"');
              opts = secondOpts.replace(/’/g, '"');
            }
            x['optionsArray'] = (x.PollOptions != "" && x.PollOptions != null && x.PollOptions != undefined) ? JSON.parse(opts) : [];
            x['PollId'] = [];
            return x;
          })
          pollsExcelData.map((x) => {
            let optionId = [];
            if (x.PollType === 'MCQ_SINGLE' || x.PollType === 'MCQ_MULTIPLE') {
              if (x.optionsArray.length > 0) {
                for (var i = 0; i < x.optionsArray.length; i++) {
                  if (x.optionsArray[i] == "") {
                    x.optionsArray[i] = null;
                  }
                }
              }

              if (x.optionsArray.length > 0) {
                x.optionsArray.map(item => {
                  let opt = new PollOptionsModel();
                  opt.option = item;
                  optionId.push(this.pollService.addPollOptions(this.eventID, opt));
                });
              }
            }
            let payload = new PollQuestionModel();
            payload.eventId = this.eventID
            payload.pollQuestion = x.PollQuestions
            payload.pollType = x.PollType
            payload.options = x.options
            payload.isMandatory = (x.IsMandatory != "" && x.IsMandatory != null && x.IsMandatory != undefined) ? x.IsMandatory.toUpperCase() == "TRUE" ? true : false : false
            payload.showResult = (x.ShowResult != "" && x.ShowResult != null && x.ShowResult != undefined) ? x.ShowResult.toUpperCase() == "TRUE" ? true : false : false
            payload.allowOverwrite = (x.AllowOverwrite != "" && x.AllowOverwrite != null && x.AllowOverwrite != undefined) ? x.AllowOverwrite.toUpperCase() == "TRUE" ? true : false : false
            payload.isReleased = (x.IsRelease != "" && x.IsRelease != null && x.IsRelease != undefined) ? x.IsRelease.toUpperCase() == "TRUE" ? true : false : false
            payload.options = optionId;

            if (x.PollKey) {
              payload.pollId.push(x.PollKey);
            }
            payloadArr.push(payload)
            if (payloadArr.length > 0)
              bulkUploadTrigger = true;

          })
          setInterval(() => {
            if (bulkUploadTrigger) {
              this.removeFileInstance(event, uploader, 0);
              payloadArr.map((x) => {
                //debugger
                const tempPolls = this.pollService.addPollQuestion(this.eventID, x);
                if (tempPolls != null && tempPolls != undefined) {
                  this.pollService.getPollDetail(this.eventID, x.pollId[0]).subscribe((prevPollsDetails) => {

                    if (prevPollsDetails != null && prevPollsDetails != undefined) {
                      let PrevNewQuestionSet = [];
                      if (prevPollsDetails.questions !== undefined) {
                        PrevNewQuestionSet = Object.values(prevPollsDetails.questions);
                      }
                      PrevNewQuestionSet.push(tempPolls);
                      let prevQuestionSet = PrevNewQuestionSet.filter((v, i, a) => a.indexOf(v) === i);
                      this.pollService.updatePollDetail(this.eventID, x.pollId[0], { ...prevPollsDetails, questions: prevQuestionSet });
                    }

                  })
                }
              })
              this.message = "Question Imported Successfully!"
              bulkUploadTrigger = false;
            }
          }, 1000);

        }
      }

    }).catch(error => {
      this.removeFileInstance(event, uploader, 0);
      bulkUploadTrigger = false;
      console.log(error);
    });
  }

  setPollList(id) {
    this.message = null;
    var x = this.pollService.getPollList(id)
    x.snapshotChanges().subscribe(list => {
      if (this.checkData) {
        this.pollDeletedIdList = new Array();
        this.pollList = new Array();
        this.pollIdList = new Array();
        list.forEach(element => {
          if (element.key) {
            var y = element.payload.toJSON() as Poll;
            y["$key"] = element.key;
            if (this.pollIdList.indexOf(element.key + "") == -1) {
              this.pollIdList.push({ eventLists: this.eventLists = true });

              this.pollList[y.position] = (y as Poll);

              this.pollList[y.position].options = Object.assign([], this.pollList[y.position].options);
              this.pollList[y.position].counters = new Array();
              this.pollList[y.position].options.forEach(element => {
                this.pollList[y.position].counters.push(0);
              });
            }
            console.log(this.pollList)
          }
        });
        this.checkData = false;
        this.setPollListData(id);
      }
    });
  }

  setPollQuestionList(id) {
    var x = this.pollService.getPollQuestionList(id)
    x.snapshotChanges().subscribe(list => {
      if (list) {
        // console.log(list);
        this.pollQuestionList = new Array<PollQuestionModel>();
        list.forEach(element => {
          if (element.key) {
            var y = element.payload.toJSON() as PollQuestionModel;
            y["$key"] = element.key;
            this.pollQuestionList.push(y);
            // console.log(y)
          }
        });
        console.log(this.pollQuestionList);
      }
    });
  }


  setPollListData(id) {
    this.pollListService.getPollListData(id).subscribe(event => {
      if (event) {
        this.totalAnswer = new Array();
        for (let key in event) {
          if (key) {
            if (event[key].answers) {

              for (let o in event[key].answers) {

                let count = 0;
                let optList = this.pollList.filter(val => val.$key == key);
                if (optList && optList.length > 0) {

                  for (let option of optList[0].options) {

                    if (event[key].answers[o] == option) {
                      let index = optList[0].options.indexOf(option);
                      optList[0].counters[index] = optList[0].counters[index] + 1;
                      break;
                    }

                    optList[0].totalAnswer = event[key].answersCount;

                  }

                }

              }

            }

          }

        }
      }

    });

  }


  confirmDelete(event: Poll) {
    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_POLL,
      accept: () => {
        this.deleteEvent(event);
      }
    });
  }

  pollDeletedIdList = new Array<string>();
  deleteEvent(event) {
    // this.pollDeletedIdList.push(event.$key);
    let index: number = this.pollList.indexOf(event);
    if (index !== -1) {
      this.pollList.splice(index, 1);
    }

    for (var i = 0; i < this.pollList.length; i++) {
      this.pollList[i].position = i;
    }

    this.pollService.deletePollID(event, this.eventID, this.pollList).then(res => {
      this.message = "Poll deleted Successfully";
    }).catch(error => {
      console.log(error.message);
    });
    setTimeout(() => {
      this.message = null;
      this.checkData = true;
      this.setPollList(this.eventID);
    }, 1000);

  }


  confirmDeleteQuestion(questionId) {
    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_POLL_QUESTION,
      accept: () => {
        this.deleteQuestionEvent(questionId);
      }
    });
  }

  deleteQuestionEvent(questionId) {
    console.log(questionId);
    this.pollService.deletePollQuestionID(questionId, this.eventID).then(res => {
      this.message = "Question deleted Successfully";
    }).catch(error => {
      console.log(error.message);
    });
    setTimeout(() => {
      this.message = null;
      this.checkData = true;
      this.setPollQuestionList(this.eventID);
    }, 1000);
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/poll-form/poll-form.component.ts